import { render } from "./FeedbackChat.vue?vue&type=template&id=519728fc&scoped=true"
import script from "./FeedbackChat.vue?vue&type=script&lang=js"
export * from "./FeedbackChat.vue?vue&type=script&lang=js"

import "./FeedbackChat.vue?vue&type=style&index=0&id=519728fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519728fc"]])

export default __exports__